import { defineStore } from 'pinia';
import { deepMerge } from '@common/utils/common';
import proxyModel from './interceptor';
import { msSessionStorage } from '@common/utils/cache';

// 领域表模型及操作内容
export type TDomainOpts = {
  table: object;
  actions: object;
};

// 用来存储其他双向绑定仓储工具
let otherStoreFn;
export const changeStore = (fn) => (otherStoreFn = fn);

const reactiveStore = (title, domainOpts) => {
  // 如果存在其他仓库方法，则使用新注入仓库方法
  if (otherStoreFn) {
    return otherStoreFn({ title, domainOpts });
  }
  // 默认使用pinia
  return defineStore(title, {
    state: (): object => domainOpts.table,
    actions: domainOpts.actions,
  });
};

export default (domainOpts: TDomainOpts, title = '', opts?): any => {
  // 如果需要存储内容为响应式类型
  if (opts?.reactive) {
    // 调用响应式工具
    const useDomain = reactiveStore(title, domainOpts);

    return useDomain;
  } else {
    // 如果缓存中已经存在实体信息了，那么合并后赋值给表格
    if (msSessionStorage.get(title)) {
      deepMerge(domainOpts.table, msSessionStorage.get(title));
    }

    // 将内容整体劫持下
    const resultModel = proxyModel(domainOpts, title);

    // 更改actions中this指向
    for (const action in domainOpts.actions) {
      // 如果模型中存在actions中注册的动作，则更改动作中this指向为当前表格
      if (resultModel[action]) {
        resultModel[action] = resultModel[action].bind(resultModel);
      }
    }
    return () => resultModel;
  }
};
